(function () {
  "use strict";

  var form = document.getElementById("widerruf-form");
  if (!form) return;

  var formWrapper = document.getElementById("widerruf-form-wrapper");
  var confirmationWrapper = document.getElementById("widerruf-confirmation");
  var submitButton = document.getElementById("widerruf-submit");
  var errorBox = document.getElementById("widerruf-error");

  var scopeRadios = form.querySelectorAll('input[name="scope"]');
  var productsWrapper = document.getElementById("wf-products-wrapper");
  var productsField = document.getElementById("wf-products");

  // Teilwiderruf: Produktfeld nur einblenden und nur dann verpflichtend,
  // wenn "nur einzelne Produkte" gewählt ist.
  function updateProductsVisibility() {
    var scope = form.querySelector('input[name="scope"]:checked').value;
    if (scope === "teilweise") {
      productsWrapper.hidden = false;
      productsField.required = true;
    } else {
      productsWrapper.hidden = true;
      productsField.required = false;
      productsField.value = "";
    }
  }

  scopeRadios.forEach(function (radio) {
    radio.addEventListener("change", updateProductsVisibility);
  });
  updateProductsVisibility();

  function showError(message) {
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function clearError() {
    errorBox.hidden = true;
    errorBox.textContent = "";
  }

  function isValidEmail(value) {
    // Bewusst einfache Prüfung; die eigentliche Validierung erfolgt
    // serverseitig im Worker.
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();
    clearError();

    var name = form.name.value.trim();
    var email = form.email.value.trim();
    var orderNumber = form.orderNumber.value.trim();
    var scope = form.querySelector('input[name="scope"]:checked').value;
    var affectedProducts = productsField.value.trim();
    var message = form.message.value.trim();
    var honeypot = form.website.value.trim();

    if (!name || !email || !orderNumber) {
      showError("Bitte füllen Sie alle Pflichtfelder aus.");
      return;
    }
    if (!isValidEmail(email)) {
      showError("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
      return;
    }
    if (scope === "teilweise" && !affectedProducts) {
      showError("Bitte geben Sie an, welche Produkte betroffen sind.");
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = "Wird gesendet ...";

    fetch(window.WIDERRUF_ENDPOINT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: name,
        email: email,
        orderNumber: orderNumber,
        scope: scope,
        affectedProducts: affectedProducts,
        message: message,
        website: honeypot, // Honeypot; muss serverseitig leer sein
        pageUrl: window.location.href
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data && data.error ? data.error : "Serverfehler");
          });
        }
        return response.json();
      })
      .then(function () {
        formWrapper.hidden = true;
        confirmationWrapper.hidden = false;
        confirmationWrapper.scrollIntoView({ behavior: "smooth" });
      })
      .catch(function (err) {
        submitButton.disabled = false;
        submitButton.textContent = "Widerruf bestätigen";
        showError(
          "Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es " +
          "erneut oder kontaktieren Sie uns direkt unter kontakt@eichenbierbank.de."
        );
        console.error("Widerruf-Formular Fehler:", err);
      });
  });
})();
